import { FirebaseProvider } from '../contexts/FirebaseContext';
import { useSurveyResults } from '../hooks/useSurveyResults';
import { useTranslation } from '../hooks/useTranslation';
import Chart from './charts/Chart';
import './PrintResultsPage.css';

function PrintResultsContent() {
  const { stats, loading } = useSurveyResults();
  const { translations } = useTranslation();

  // English only for print
  const questionsEn = Object.keys(translations.questions.en);
  const answersEn = Object.values(translations.questions.en) as string[][];

  if (loading) {
    return (
      <div className="print-loading">
        <p>Loading results for printing...</p>
      </div>
    );
  }

  if (!stats || !stats.responsesByQuestion) {
    return (
      <div className="print-error">
        <p>No data available for printing</p>
      </div>
    );
  }

  // Calculate end date: today if before Feb 15, 2026, otherwise Feb 15, 2026
  const today = new Date();
  const cutoffDate = new Date('2026-02-15');
  const endDate = today < cutoffDate ? today : cutoffDate;

  const formatDate = (date: Date) => {
    return date.toLocaleDateString('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric'
    });
  };

  return (
    <div className="print-results">
      <header className="print-header">
        <h1>Palais de Tokyo Visitors Poll</h1>
        <p>{stats.totalResponses} results - October 21 - {formatDate(endDate)}</p>
      </header>

      <div className="print-charts-grid">
        {questionsEn.map((questionText, index) => {
          const questionCount = stats.responsesByQuestion[index] || {};
          return (
            <div key={index} className="print-chart-container">
              <Chart
                questionNumber={index}
                questionText={questionText}
                answers={answersEn[index]}
                count={questionCount}
                totalRespondents={stats.totalResponses}
                variant="print"
              />
            </div>
          );
        })}
      </div>

    </div>
  );
}

function PrintResultsPage() {
  return (
    <FirebaseProvider>
      <PrintResultsContent />
    </FirebaseProvider>
  );
}

export default PrintResultsPage;